import React from 'react';
import { ReferenceField, TextField, useRecordContext } from 'react-admin';

// Resolves a grant's scopeId into the target entity's label (and links to it)
// based on scopeType. Country has no entity (scopeId is the code); client scope
// mirrors the grant's client.
const FeatureGrantScopeField: React.FC<{ label?: string }> = () => {
  const record = useRecordContext();
  switch (record?.scopeType) {
    case 'user':
      return (
        <ReferenceField reference="User" source="scopeId" link="show">
          <TextField source="email" />
        </ReferenceField>
      );
    case 'studio':
      return (
        <ReferenceField reference="Studio" source="scopeId" link="show">
          <TextField source="name" />
        </ReferenceField>
      );
    case 'location':
      return (
        <ReferenceField reference="CoachLocation" source="scopeId" link="show">
          <TextField source="name" />
        </ReferenceField>
      );
    case 'client':
      return (
        <ReferenceField reference="Client" source="scopeId" link="show">
          <TextField source="name" />
        </ReferenceField>
      );
    default:
      return <TextField source="scopeId" />;
  }
};

export default FeatureGrantScopeField;
